import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { StyledRow } from '../styled';
import DetailTitle from 'modules/Common/DetailTitle';
import { DetailNotFound } from './styled';

import { compose, withProps } from 'recompose';
import { injectIntl } from 'react-intl';

const enhance = compose(
  withProps(({ stop = {} }) => ({
    internal_references: stop.internal_references || [],
  }))
);

const InternalReferenceRow = React.memo(({ internal_references, intl }) => {
  const t = intl.messages.components.StopCard;
  return (
    <StyledRow>
      {(internal_references || []).length ? (
        <Fragment>
          <DetailTitle>{t.title}</DetailTitle>
          {internal_references.map((internal_reference, key) => (
            <div key={key}>{internal_reference}</div>
          ))}
        </Fragment>
      ) : (
        <DetailNotFound>{t.no_internal_reference}</DetailNotFound>
      )}
    </StyledRow>
  );
});

InternalReferenceRow.propTypes = {
  internal_references: PropTypes.array,
};

InternalReferenceRow.defaultProps = {
  internal_references: [],
};

export default enhance(injectIntl(InternalReferenceRow));
